var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('banner',{staticClass:"update-banner",attrs:{"color-scheme":"danger","banner-message":_vm.bannerMessage,"href-link":"https://api.whatsapp.com/send?phone=966920007031","href-link-text":"(Whatsapp)"}})}
var staticRenderFns = []

export { render, staticRenderFns }